<template>
    <div class="popup_wrpr_inner">
        <div class="popup">
            <div class="popup_header">
                <h3>{{getCurrentIntegration.included.attributes.active ? 'Deactivate' : 'Activate'}} a new automation</h3>
                <a @click="closePopup" class="close_popup_btn">
                    <inline-svg :src="require('@/assets/img/popup_close.svg')"/>
                </a>
            </div>
            <div class="automation-item" v-if="getCurrentIntegration.item.attributes">
                <div class="left">
                    <div class="img-wrap" v-if="getCurrentIntegration.item.attributes['small-image']">
                        <img style="height: 50px;max-width: 50px;" :src="'data:image/png;base64,'+getCurrentIntegration.item.attributes['small-image']" alt="">
                    </div>
                    <div class="text">
                        <strong>{{getCurrentIntegration.item.attributes.caption}}</strong>
                        <p>{{getCurrentIntegration.item.attributes.description}}</p>
                    </div>
                </div>
                <div class="right">
                    <label class="switch_checkbox_item"><input type="checkbox" id="checkbox" :checked="newData.included.attributes.active" v-model="newData.included.attributes.active"><div class="switch_checkbox"><span></span></div></label>
                </div>
            </div>
            <div class="content">
	            <template v-if="newData.item.id == '5' || newData.item.id == '6'">

		            <div class="margin-b-20">
			            <input-field class="right w100 form-group with-copy-icon with_top_block margin-t-10" v-if="newData.item.id == '5'"
			                         label="Your store domain name" info="Usually something like 'mystorename.myshopify.com' (without the https:// part)"
			                         v-model="newData.included.attributes.config.store_url"></input-field>
		            </div>

		            <div class="connect_to_stripe_box w100" v-if="newData.included.attributes.config.token && newData.included.attributes.config.token !== ''">
			            <h3>Connected to {{newData.item.attributes.caption}}</h3>
			            <div class="connect_to_stripe_box_innner connect">
				            <p>Click the <b>"Disconnect"</b> button below to restrict access to {{newData.item.attributes.name}}</p>
				            <v-button :loading="connecting" label="Disconnect" @click.prevent="disconnectFromService(newData.item.id)" />
			            </div>
		            </div>

		            <div class="connect_to_stripe_box w100" v-else>
			            <h3>Connect to {{newData.item.attributes.caption}}</h3>
			            <div class="connect_to_stripe_box_innner connect">
				            <p>Click the <b>"Connect"</b> button below to authorize Funnelish™ to access {{newData.item.attributes.name}}</p>
				            <v-button :loading="connecting" label="Connect" @click.prevent="connectToService(newData.item.id)"/>
			            </div>
		            </div>
	            </template>
                <div v-else class="form-group mb-24 with_top_block" v-for="(item, index) in newData.item.attributes.config" :key="index">
                    <span class="form_group_top_block">{{item.caption}}</span>
                    <input type="text" v-model="newData.included.attributes.config[item.name]" class="control-input">
                </div>
                <p class="btm-descr">
                    Feel free to contact us or start a new thread in <a href="https://community.funnelish.com">the community</a> if have any questions
                    about setting up & using this integration.
                </p>
            </div>
            <div class="bottom-btns">
                <div class="btn brdr_btn" @click="closePopup">Back to automation list</div>
                <v-button :loading="saving" @click="saveHundler" label="Save and continue" />
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import API from "@/api"
import InputField from "@/components/base/input-field";
import VButton from "@/components/base/v-button";
export default {
    name: "ActivateAutomationPopup",
	components: {VButton, InputField},
	data() {
        return {
        	saving: false,
	        connecting: false,
          checked: false,
          newData: {},
	        timer: null,
        }
    },
    mixins: [API],
    methods: {
    	clearTimer() {
    		if (this.timer)
    			clearInterval(this.timer);
	    },
	    openUrl(url) {
    		let self = this;
		    this.loadingConnection = true;
		    let win = window.open(url, "_blank");
		    this.timer = setInterval(async function() {
			    if (!win || win.closed) {
				    self.connecting = false;
				    self.clearTimer();
				    window.waitingForIntegration = null;
				    await self.reload();
				    self.$store.commit("closeActivateAutomationPopup");
			    }
		    }, 500);
	    },
	    async connectToService(id) {
    		try {
			    this.connecting = true;
			    var result = await this.api.integrations.connect(this.newData.item.attributes.name, {arg1: this.newData.included.attributes.config.store_url})
			    if (result.success) {
				    window.waitingForIntegration = this.newData.item.id;
				    this.openUrl(result.result);
			    } else throw result;
		    } catch (e) {
			    this.connecting = false;
			    this.$notify({
				    type:"warn",
				    group: "main",
				    title: "Something went wrong... Please try again later",
			    });
			    console.error("error", e);
		    } finally {
		    }
	    },
	    async disconnectFromService(id) {
	    	try {
	    		this.connecting = true;
			    var result = await this.api.integrations.disconnect(this.newData.item.attributes.name, {
				    arg1: '',
				    arg2: "",
				    id: 0
			    });
			    if (result.success) {
						await this.reload();
				    this.$store.commit("closeActivateAutomationPopup");
			    }
		    } catch (e) {
			    this.$notify({
				    type:"warn",
				    group: "main",
				    title: "Something went wrong... Please try again later",
			    });
			    console.error("error", e);
		    } finally {
			    this.connecting = false;
		    }
	    },
	    async reload() {
		    let integration = await this.api.integrations.get(this.newData.included.id)
		    this.$emit('intChanged', integration.included[0]);
	    },
        closePopup() {
            this.$store.commit("closeActivateAutomationPopup")
        },
        async saveHundler() {
            try {
            	this.saving = true;
	            var saveStr = JSON.stringify(this.newData.included);
	            var data = JSON.parse(saveStr);

	            data.attributes.config = JSON.stringify(data.attributes.config);

	            var result = await this.patchIntegration(data.id, data);
	            console.log({result});
	            this.$emit('intChanged', result.data.data);

	            this.$store.commit("closeActivateAutomationPopup");
            } catch (e) {
	            this.$notify({
		            type:"warn",
		            group: "main",
		            title: "Something went wrong... Please try again later",
	            });
	            console.error("error", e);
            } finally {
	            this.saving = false;
            }
        },
	    init() {
		    //console.log('Current integration: ', this.getCurrentIntegration);
		    var safeStr = JSON.stringify(this.getCurrentIntegration);
		    this.newData = JSON.parse(safeStr);
		    this.newData.included.attributes.config = JSON.parse(this.newData.included.attributes.config);
		    this.newData.item.attributes.config = JSON.parse(this.newData.item.attributes.config);

		    if(this.getCurrentIntegration.included.attributes.active) {
			    this.checked = true
		    } else {
			    this.checked = false
		    }
	    }
    },
    computed: {
        ...mapGetters(["getCurrentIntegration"]),
    },
	beforeDestroy() {
		this.clearTimer();
	},
	beforeMount() {
        this.init();
    }
}
</script>
<style lang="scss" scoped>
.connect_to_stripe_box {
	border-radius: 15px;
	background: $light-blue;
	padding: 15px;
}
</style>
